const e = {
  name: "Trophy",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M31,0H5v5H0v8c0,3.9,3.1,7,7,7h0c2.1,3.3,5.8,5.6,10,6v4.1c-3.9,0.5-7,3.9-7,7.9H8v2h20v-2h-2
			c0-4.1-3.1-7.4-7-7.9V26c4.2-0.3,7.8-2.6,10-6h0c3.9,0,7-3.1,7-7V5h-5V0z M6,17.9c-2.3-0.5-4-2.5-4-4.9V7h3v6
			C5,14.7,5.3,16.4,6,17.9z M34,13c0,2.4-1.7,4.4-4,4.9c0.6-1.5,1-3.2,1-4.9V7h3V13z M7,13V2h22v11c0,6.1-4.9,11-11,11S7,19.1,7,13z
			 M12,38c0-3.3,2.7-6,6-6s6,2.7,6,6H12z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Trophy
};
